import { newSecretManagerElement } from "@p0security/integrations-vaulted-credential-shared";
import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

const allSecretManagers = newSecretManagerElement({
  owner: "GitHub App",
  connector: "GitHub",
});

// The AWS connector has no Terraform yet, and the gateway reads only Google
// Secret Manager vaults, so an AWS install could not serve an agent.
const SecretManager = Element({
  ...allSecretManagers,
  default: "gcp-sm",
  options: {
    ...allSecretManagers.options,
    "aws-sm": { ...allSecretManagers.options["aws-sm"], hidden: true },
  },
});

export const GithubAiComponents = InstallSpec({
  credential: ItemComponent({
    label: "Credential provisioning",
    description: "Allow P0 to grant machines access to GitHub",
    type: "string",
    maturity: "beta",
    schema: {
      secretManager: SecretManager,
      appId: Element({
        label: "GitHub App ID",
        description: "ID of the GitHub App created for access provisioning",
        type: "string",
      }),
    },
  }),
});
